// extracted by mini-css-extract-plugin
module.exports = {"errorBox":"ErrorBox-module__errorBox___gzt5M"};